module.exports = __webpack_public_path__ + "img/facebook-logo-white.a0fd1581.svg";